import React, { useEffect, useMemo, useState } from 'react'
import injectSheet from 'react-jss'
import { usePresentationPattern } from 'pobble-components/dist/presentation-utils'
import VideoThumbnail from './slide-types/video/thumbnail'
import ImageThumbnail from './slide-types/image/thumbnail'
import SuccessCriteriaThumbnail from './slide-types/success-criteria/thumbnail'
import ExemplarThumbnail from './slide-types/exemplar/thumbnail'
import WordBankThumbnail from './slide-types/word-bank/thumbnail'
import classNames from 'classnames'

const thumbnails = {
  Video: VideoThumbnail,
  Image: ImageThumbnail,
  SuccessCriteria: SuccessCriteriaThumbnail,
  Exemplar: ExemplarThumbnail,
  WordBank: WordBankThumbnail
}

const thumbnailStyles = {
  container: {
    paddingBottom: '56.25%',
    position: 'relative',
    background: '#f7f7f7',
    fontSize: '16px',
    '& > *': {
      opacity: '0'
    }
  },
  loaded: {
    '& > *': {
      animation: 'fadeIn .4s ease-in forwards'
    }
  },
  img: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
      display: 'block'
    }
  },
  holder: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}

export const PresentationThumbnail = injectSheet(thumbnailStyles)(
  ({ classes, presentation, className }) => {
    const [loaded, setLoaded] = useState(false)
    const pattern = usePresentationPattern(presentation.pattern)

    const image =
      presentation.image_url ||
      (presentation.image && presentation.image.medium_url)

    const assetData = useMemo(() => {
      if (!presentation.asset) return null
      return (
        presentation.asset_data ||
        (presentation.slides && presentation.slides[2])
      )
    })

    useEffect(() => {
      !presentation.asset && !image && setLoaded(true)
    }, [presentation])

    // Force loaded state after 2 seconds
    useEffect(() => {
      const t = setTimeout(() => {
        if (!loaded) setLoaded(true)
      }, 2000)
      return () => {
        clearTimeout(t)
      }
    }, [])

    const AssetThumbnail = useMemo(() => {
      if (!assetData) {
        return null
      } else {
        return thumbnails[assetData.type]
      }
    }, [assetData])

    const patternStyle = {
      backgroundColor: pattern.color,
      backgroundImage: `url("${pattern.pattern}")`
    }

    return (
      <div
        className={classNames(
          classes.container,
          { [classes.loaded]: loaded },
          className
        )}>
        {!AssetThumbnail && (
          <div className={classes.img} style={!image ? patternStyle : null}>
            {image && (
              <img
                onLoad={() => setLoaded(true)}
                src={image}
                alt="presentation cover"
              />
            )}
          </div>
        )}

        {AssetThumbnail && (
          <div className={classes.holder}>
            <AssetThumbnail
              onLoad={() => setLoaded(true)}
              presentation={presentation}
              slide={assetData}
            />
          </div>
        )}
      </div>
    )
  }
)
